import { useState } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import { FacebookIcon, LinkedinIcon, XIcon, WhatsappIcon } from "react-share";

type TVideoShareButtonsProps = {
  videoUrl: string;
};

const VideoShareButtons = ({ videoUrl }: TVideoShareButtonsProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyLink = async (e: React.MouseEvent) => {
    e.preventDefault();
    
    try {
    
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(videoUrl);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } else {
         
        fallbackCopyTextToClipboard(videoUrl);
      }
    } catch (err) {
      console.error("Failed to copy link: ", err);
      
      fallbackCopyTextToClipboard(videoUrl);
    }
  };

  const fallbackCopyTextToClipboard = (text: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      } else {
        console.error('Fallback: Unable to copy');
      }
    } catch (err) {
      console.error('Fallback: Unable to copy', err);
    }
    
    document.body.removeChild(textArea);
  };

  return (
    <div>
      <div className="shareBox">
        <h2>Share</h2>
        <center>
          <TwitterShareButton
            url={videoUrl}
            className="Demo__some-network__share-button"
          >
            <XIcon className="ShareIcon" size={60} round={true} />
          </TwitterShareButton>
          <WhatsappShareButton url={videoUrl}>
            <WhatsappIcon className="ShareIcon" size={60} round={true} />
          </WhatsappShareButton>
          <FacebookShareButton url={videoUrl}>
            <FacebookIcon className="ShareIcon" size={60} round={true} />
          </FacebookShareButton>
          <LinkedinShareButton url={videoUrl}>
            <LinkedinIcon className="ShareIcon" size={60} round={true} />
          </LinkedinShareButton>
        </center>
        <form onSubmit={(e) => e.preventDefault()}>
          <input type="text" value={videoUrl} readOnly />
        </form>
        <button 
          type="button" 
          className="share-btn" 
          onClick={copyLink}
        >
          Copy
        </button>
        {isCopied && <p className="copied-text">Link copied to clipboard!</p>}
      </div>
    </div>
  );
};

export default VideoShareButtons;